import { render, staticRenderFns } from "./AddEditGroup.vue?vue&type=template&id=b1d52530&scoped=true"
import script from "./AddEditGroup.vue?vue&type=script&lang=js"
export * from "./AddEditGroup.vue?vue&type=script&lang=js"
import style0 from "./AddEditGroup.vue?vue&type=style&index=0&id=b1d52530&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d52530",
  null
  
)

export default component.exports